import styled from "@emotion/styled";
import { Card } from "@mui/material";

export const CartItemWrapper = styled(Card)<{ isEdit: boolean }>(({ theme, isEdit }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	minHeight: "120px",
	color: theme.project.colors.fontColors.main,
	padding: "0 32px",
	borderRadius: "unset",
	display: "grid",
	alignItems: "center",
	columnGap: "10px",
	gridTemplateColumns: isEdit ? "4fr 1fr 2fr 1fr 1fr 1fr" : "24px 4fr 2fr 1fr 1fr 1fr"
}));

export const LineItemNumber = styled.p({
	placeSelf: "start",
	margin: "28px 0 0"
});

export const CartItemSku = styled.p(({ theme }) => ({
	...theme.project.typography.heading.h6,
	fontWeight: 400,
	margin: 0,
	fontsize: "34px",
	cursor: "pointer",
	userSelect: "none",
	"&:hover": {
		textDecoration: "underline"
	},
	"&:focus-visible": {
		outline: `2px solid ${theme.project.colors.primaryColors.main}`,
		outlineOffset: "2px"
	}
}));
export const CartItemDescription = styled.p(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1
}));

export const Thumbnail = styled.img({
	height: "81px",
	width: "100px",
	objectFit: "contain",
	display: "block"
});
